import * as React from 'react'
import { Check, Cancel } from '../icons'

const PasswordCriterion = ({ criterion, isWhiteText, children }) => {
  return (
    <li className={`mb-4 ${isWhiteText ? 'text-white' : 'text-4'}`}>
      {/* CTS-9265 (YNS-014): icons decorative; SR gets Met/Not met from sr-only text */}
      <span className="mr-2 align-text-bottom" aria-hidden="true">
        {criterion ? <Check /> : <Cancel />}
      </span>
      <span className="sr-only">{criterion ? 'Met: ' : 'Not met: '}</span>
      {children}
    </li>
  )
}

export default PasswordCriterion
